import { ChevronLeft, ChevronRight } from "lucide-react";

/** Shared prev/next pager footer for admin list tables. */
export default function Pager({ page, total, pageSize, itemLabel = "items", onChange, testId = "pager" }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 px-4 md:px-6 py-3 border-t border-nhp-border">
      <div className="text-xs text-nhp-muted font-mono">
        {total === 0 ? `0 ${itemLabel}` : `${(page - 1) * pageSize + 1}–${Math.min(page * pageSize, total)} of ${total}`}
      </div>
      <div className="flex items-center gap-2">
        <button
          type="button"
          data-testid={`${testId}-prev-page`}
          disabled={page <= 1}
          onClick={() => onChange(Math.max(1, page - 1))}
          className="h-8 w-8 grid place-items-center border border-nhp-border text-nhp-text disabled:opacity-30 hover:bg-nhp-bg"
        >
          <ChevronLeft className="h-4 w-4" />
        </button>
        <span className="text-xs font-mono text-nhp-muted">Page {page} / {totalPages}</span>
        <button
          type="button"
          data-testid={`${testId}-next-page`}
          disabled={page >= totalPages}
          onClick={() => onChange(Math.min(totalPages, page + 1))}
          className="h-8 w-8 grid place-items-center border border-nhp-border text-nhp-text disabled:opacity-30 hover:bg-nhp-bg"
        >
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
